import { Controller } from "@hotwired/stimulus"

// Suivi temps réel d'un import FEC : poll l'endpoint `status` (JSON), met à jour la
// barre de progression, et recharge la page quand le traitement est terminé
// (l'écran suivant : validation du mapping ou récapitulatif d'import).
export default class extends Controller {
  static values = { url: String, interval: Number }
  static targets = ["bar", "label", "pct"]

  connect() {
    this.poll()
    this.timer = setInterval(() => this.poll(), this.intervalValue || 1500)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  async poll() {
    try {
      const res = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      if (!res.ok) return
      const data = await res.json()

      if (this.hasBarTarget && data.pct != null) this.barTarget.style.width = data.pct + "%"
      if (this.hasPctTarget && data.pct != null) this.pctTarget.textContent = data.pct + "%"
      if (this.hasLabelTarget && data.label) this.labelTarget.textContent = data.label

      const enCours = ["televerse", "analyse", "import_en_cours"].includes(data.statut)
      if (!enCours) {
        clearInterval(this.timer)
        window.location.reload()
      }
    } catch (_e) {
      // on réessaie au prochain tick
    }
  }
}
